/**
* สำนักงานจริงที่มีที่อยู่จดทะเบียน (นอกเหนือจากสำนักงานใหญ่กรุงเทพฯ)
*
* COMPLIANCE: เฉพาะจุดที่เราตั้งสำนักงานจริงและตรวจสอบได้เท่านั้นจึงจะมี
* `street` / `postalCode` / `mapUrl` ห้ามเพิ่มที่อยู่ที่ไม่มีสำนักงานจริง
*/
import { branch, type Branch } from "./types";

export const OFFICE_LOCATIONS: Branch[] = [
  branch({
    id: "th-khon-kaen-office",
    name: "สำนักงานสาขาขอนแก่น",
    shortName: "สาขาขอนแก่น",
    street: "46/1-2 หมู่ 2 ถนนฉิมพลี",
    locality: "ตำบลในเมือง อำเภอเมืองขอนแก่น",
    region: "ขอนแก่น",
    postalCode: "40000",
    geo: { lat: 16.4322, lng: 102.8365 },
    branchType: "province",
    provinceSlug: "khon-kaen",
    mapUrl: "https://maps.app.goo.gl/Nu8dizGAkGBd8Yyg6",
    landmarks: ["บึงแก่นนคร", "เซ็นทรัล ขอนแก่น"],
    transit: ["สถานีรถไฟขอนแก่น", "บขส. ขอนแก่น แห่งที่ 3"],
    serviceFocus: ["notary", "translation", "sworn", "lgz", "moj", "pcc", "visa", "marriage", "corporate"],
    note: "ศูนย์บริการภาคอีสานตอนกลาง รับรองเอกสารและแปลรับรองครบวงจร",
  }),
  branch({
    id: "th-udon-thani-office",
    name: "สำนักงานสาขาอุดรธานี",
    shortName: "สาขาอุดรธานี",
    street: "31/43 ถนนศรีชมชื่น",
    locality: "ตำบลหมากแข้ง อำเภอเมืองอุดรธานี",
    region: "อุดรธานี",
    postalCode: "41000",
    geo: { lat: 17.4103, lng: 102.7887 },
    branchType: "province",
    provinceSlug: "udon-thani",
    mapUrl: "https://maps.app.goo.gl/PKjqJXTkWNxUjZFD7",
    landmarks: ["ยูดีทาวน์ (UD Town)", "เซ็นทรัล อุดรธานี"],
    transit: ["สถานีรถไฟอุดรธานี", "สนามบินนานาชาติอุดรธานี"],
    serviceFocus: ["notary", "translation", "sworn", "lgz", "moj", "pcc", "visa", "marriage", "immigration"],
    note: "ศูนย์บริการภาคอีสานตอนบน ใกล้ด่านหนองคาย–เวียงจันทน์",
  }),
];
